import React from "react";
import { Helmet } from "react-helmet-async";

import styles from "./ComplexCheckout.module.scss";

export const ComplexCheckout: React.FC = () => {
  return (
    <div className={styles.Page}>
      <Helmet>
        <title>Оформление проекта — ЛОГМОЛЛ</title>
      </Helmet>

      {/* TODO: ComplexCheckout */}
    </div>
  );
};
